import React from 'react';
import { CiHeart } from 'react-icons/ci';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

import * as S from './styles';
import { Product } from 'types/Product';
import { shrinkText, formatCurrency } from 'utils/functions';
import { png } from 'utils/imgList';

interface DefaultProps {
	product: Product;
}

export default function Default({ product }: DefaultProps) {
	function returnStarts() {
		return (
			<>
				<AiFillStar />
				<AiFillStar />
				<AiFillStar />
				<AiFillStar />
				<AiOutlineStar />
			</>
		);
	}

	return (
		<S.container>
			<S.like>
				<CiHeart />
			</S.like>

			<S.photo>
				<img
					src={product?.items?.[0]?.images?.[0]?.imageUrl ?? png.noImg}
					alt={product.productName}
				/>
			</S.photo>

			<S.infos>
				<S.title>
					<b> {shrinkText(product.productName, 35)}</b>
				</S.title>

				<S.description
					dangerouslySetInnerHTML={{
						__html: shrinkText(product.description, 25)
					}}
				/>

				<S.brand>
					<p> {shrinkText(product.brand, 15)}</p>
				</S.brand>

				<S.starts>{returnStarts()}</S.starts>

				<S.price>
					{formatCurrency(
						product?.items?.[0]?.sellers?.[0]?.commertialOffer?.Price || 0
					)}
				</S.price>
			</S.infos>
			<S.btnBuy>
				<p>Adicionar à sacola</p>
			</S.btnBuy>
		</S.container>
	);
}
